import React from 'react';
import { useDeviceDetection } from '../hooks/useDeviceDetection';
import InformeAvanceView from './InformeAvanceView';
import InformeAvanceMovilView from './InformeAvanceMovilView';

/**
 * Vista automática que detecta el dispositivo y muestra
 * la versión apropiada del Informe de Avance
 */
const InformeAvanceAutoView: React.FC = () => {
  const { isMobile, isTablet } = useDeviceDetection();

  const esMobileOTablet = isMobile || isTablet;

  if (esMobileOTablet) {
    return <InformeAvanceMovilView />;
  }

  return <InformeAvanceView />;
};

export default InformeAvanceAutoView;
